import React from 'react';
import VisibleBotMark from '../VisibleBotMark/VisibleBotMark';
import {checkIfBotMarkShown} from '../../utils/bots/checkIfBotMarkShown';

/**
 * Никнейм игрока в списке лобби. У «явного» бота рейтингового матча значок его
 * лиги стоит сразу справа от никнейма — один раз, а не на каждой из выпавших
 * ему фракций (иконки фракций в лобби рисуются с hideVisibleBotMark). Там же
 * стоит метка ИИ-игрока промо-матча (isAi). Обычный бот, выдающий себя за
 * живого, значка не получает.
 */
const LobbyPlayerName = ({player}) => (
  <div className="lobby-player-name-container">
    <span className="lobby-player-name" title={player.name}>{player.name}</span>
    {checkIfBotMarkShown(player) && <VisibleBotMark player={player} className="lobby-player-bot-mark"/>}
  </div>
);

export default LobbyPlayerName;
